import React from 'react'

const IcUnlinkBank = (props) => {
    return (
        <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="12" fill="#F45C5C"/>
        <path d="M13.666 17.3346H5.99935C5.26297 17.3346 4.66602 16.7377 4.66602 16.0013V8.0013C4.66602 7.26492 5.26297 6.66797 5.99935 6.66797H17.9993C18.7357 6.66797 19.3327 7.26492 19.3327 8.0013V11.3346" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4.66602 10.668H19.3327" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4.66602 10.668H19.3327" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M19.334 13.332L15.334 17.332" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M15.334 13.332L19.334 17.332" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    )
}

export default IcUnlinkBank
